<template lang="pug">
    #tasks.center-panel
        md-content.content-area(md-theme="white" v-loader-overlay="progress")
            <tasks-list v-bind:tasks="tasks"></tasks-list>
</template>
<script>
import moment from 'moment'
import EditArea from '@/components/EditArea'
import SortTable from '@/components/SortTable'
import TasksList from '@/components/TasksList'

export default {
  components: {EditArea, SortTable, TasksList},
  data() {
    return {
      title: 'Задачи',
      tasks: [],
      filter: {
        project_id: 'all',
        status_id: 'all',
        responsible_id: null,
        search: null
      }
    }
  },
  metaInfo() {
    return {
      title: this.title
    }
  },
  created() {
    //this.getTasks();
    this.$store.commit('setTitle', 'Задачи');
    this.listenters();
  },
  computed: {
    progress() {
      return this.progressObj['get-tasks-list'];
    },
    progressObj() {
      return this.$store.state.progressObj;
    },
    dbTasks() {
      return this.$store.state.tasks.tasks;
    },
    groupBy() {
      return this.$store.state.tasks.groupBy;
    },
    orderBy() {
      return this.$store.state.tasks.orderBy;
    },
  },
  methods: {
    //получение списка задач
    getTasks(orderBy, orderOrder, filter, customFilter) {
        this.$store.commit('showProgressBar', 'get-tasks-list');
        let params = {
            order_by:   (orderBy)    ? orderBy    : ((this.orderBy) ? this.orderBy : 'id'),
            order_type: (orderOrder) ? orderOrder : 'asc',
            filter:     (filter)     ? filter     : {model: [], relation: []},
            customFilter: (customFilter) ? customFilter : null
        };
    
        return this.$store.dispatch('tasks/getTasksNew', params).then(r => {
            if (r && r.length) this.tasks = Object.assign([], r);
            else this.tasks = Object.assign([], []);
            return r;
        }).finally(() => this.$store.commit('hideProgressBar', 'get-tasks-list'));
    },
    listenters() {
      this.$root.$on('tasks-filter', filter => this.getTasks(null, null, null, filter));
      this.$root.$on('update-task', task => {
        if (task && task.id && this.tasks && this.tasks.length) this.tasks.map((item, i) => {
          if (parseInt(item.id) == parseInt(task.id)) this.helpers.object.softUpdate(item, task);
        });
      });
      this.$root.$on('update-task-list', task => {
        let add = true;
        if (this.filter.project_id     && this.filter.project_id     != 'all' && parseInt(this.filter.project_id)     != parseInt(task.project_id))     add = false;
        if (this.filter.status_id      && this.filter.status_id      != 'all'&&  parseInt(this.filter.status_id)      != parseInt(task.status_id))      add = false;
        if (this.filter.responsible_id && this.filter.responsible_id != 'all'&&  parseInt(this.filter.responsible_id) != parseInt(task.responsible_id)) add = false;
        if (add) this.tasks.push(task);
      });
      this.$root.$on('delete-task', id => {
        let taskIndex = null;
        this.tasks.map((item, i) => {
          if (parseInt(item.id) == parseInt(id)) taskIndex = i;
        });
        if (taskIndex && taskIndex != null) this.tasks.splice(taskIndex, 1);
      });
    },
    //подгодовка новой пустой задачи
    addTask(group) {
      this.newTask = {
        name: '',
        description: '',
        parent_task_id: null,
        taskmaster_id: this.$store.state.users.current.id,
        responsible_id: this.$store.state.users.current.id,
        group_id: null,
        status: 1,
        status_id: typeof group.status != 'undefined' ? group.status.id : null,
        project_id: typeof this.$route.params.projectid != 'undefined' && this.$route.params.projectid != 'all' ?  this.$route.params.projectid : null,
        type: 1,
        id: null,
        deadline: null
      }
    },
    //сохранение задачи
    saveTask() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.$store.commit('showProgressBar', 'get-tasks-list');
          this.$store.dispatch('tasks/addTask', { task: this.newTask }).then(task => {
            this.$router.push({ name: 'Task', params: { projectid: this.$route.params.projectid, taskid: task.id }});
            this.$store.commit('hideProgressBar', 'get-tasks-list');
            this.getTasks();
          });
          this.newTask = null
        }
      })
    },
    //изменение стаутса задачи
    changeStatus(task) {
      if (task.status == null) task.status = 1;
      this.$store.commit('showProgressBar', 'get-tasks-list');
      this.$store.dispatch('tasks/updateTask', { task: task }).then(() => {
          this.$store.commit('hideProgressBar', 'get-tasks-list');
          this.getTasks();
      });
    },
    //удаление задачи
    deleteTask(task_id) {
      this.$store.commit('showProgressBar', 'get-tasks-list');
      this.$store.dispatch('tasks/deleteTask', { task_id: task_id }).then(r => {
          this.$store.commit('hideProgressBar', 'get-tasks-list');
          this.getTasks();
      });
      //переадресация в группу/проект удалённой задачи
      this.$router.push({ name: 'Tasks', params: { projectid: this.$route.params.projectid }})
    },
    //добавление категории
    addStatus() {
      this.$store.dispatch('tasks/addStatus', { status_name: this.statusName, project_id: this.$route.params.projectid });
      this.newStatus = false;
      this.statusName = ''
    },
    //сохранение статуса
    saveStatus(status) {
      this.visibleSortField = null
      this.$store.dispatch('tasks/updateStatus', { status: status })
    },
    //удаление статуса
    deleteStatus(status_id) {
      this.$store.dispatch('tasks/deleteStatus', { status_id: status_id })
    },
    //сохранение проекта
    saveProject() {
      this.$store.commit('showProgressBar', 'get-tasks-list');
      this.$store.dispatch('tasks/updateProject', { project: this.project }).then(() => {
          this.$store.commit('hideProgressBar', 'get-tasks-list');
      });
    },
    //включение поля редактирования сортировки
    toggleSort(group) {
      this.visibleSortField = group.status.id
    }
  },
  watch: {
  }
}
</script>
<style lang="sass"></style>



// WEBPACK FOOTER //
// Tasks.vue?35603b3f